export default __webpack_public_path__ + "static/media/yahoo.4aa8d800.svg";